import { query } from "./strapi";

export interface FAQ {
  id: number;
  question: string;
  answer: string;
}

export interface FAQCategory {
  id: number;
  name: string;
  faqs: FAQ[];
}

export interface FAQData {
  categories: FAQCategory[];
}

// Get all FAQ data grouped by category
export async function getFaqData(): Promise<FAQData> {
  try {
    const response = await query("faq");

    if (!response || !response.faqs) {
      return { categories: [] };
    }

    // Transform the data into the desired format
    return {
      categories: response.faqs.map((category: any) => ({
        id: category.id,
        name: category.category,
        faqs: category.faq.map((faq: any) => ({
          id: faq.id,
          question: faq.question,
          answer: faq.answer,
        })),
      })),
    };
  } catch (error) {
    console.error("Error fetching FAQ data:", error);
    return { categories: [] };
  }
}
